// Pulled from https://git.hubteam.com/HubSpot/ecosystem/blob/master/ecosystem-data/src/main/java/com/hubspot/ecosystem/models/reviews/reviews/Industry.java

/** @deprecated use marketplace-ui-reviews */
export const ACCOUNTING = 'ACCOUNTING';
/** @deprecated use marketplace-ui-reviews */

export const AIRLINES_AVIATION = 'AIRLINES_AVIATION';
/** @deprecated use marketplace-ui-reviews */

export const ALTERNATIVE_DISPUTE_RESOLUTION = 'ALTERNATIVE_DISPUTE_RESOLUTION';
/** @deprecated use marketplace-ui-reviews */

export const ALTERNATIVE_MEDICINE = 'ALTERNATIVE_MEDICINE';
/** @deprecated use marketplace-ui-reviews */

export const ANIMATION = 'ANIMATION';
/** @deprecated use marketplace-ui-reviews */

export const APPAREL_FASHION = 'APPAREL_FASHION';
/** @deprecated use marketplace-ui-reviews */

export const ARCHITECTURE_PLANNING = 'ARCHITECTURE_PLANNING';
/** @deprecated use marketplace-ui-reviews */

export const ARTS_CRAFTS = 'ARTS_CRAFTS';
/** @deprecated use marketplace-ui-reviews */

export const AUTOMOTIVE = 'AUTOMOTIVE';
/** @deprecated use marketplace-ui-reviews */

export const AVIATION_AEROSPACE = 'AVIATION_AEROSPACE';
/** @deprecated use marketplace-ui-reviews */

export const BANKING = 'BANKING';
/** @deprecated use marketplace-ui-reviews */

export const BIOTECHNOLOGY = 'BIOTECHNOLOGY';
/** @deprecated use marketplace-ui-reviews */

export const BROADCAST_MEDIA = 'BROADCAST_MEDIA';
/** @deprecated use marketplace-ui-reviews */

export const BUILDING_MATERIALS = 'BUILDING_MATERIALS';
/** @deprecated use marketplace-ui-reviews */

export const BUSINESS_SUPPLIES_EQUIPMENT = 'BUSINESS_SUPPLIES_EQUIPMENT';
/** @deprecated use marketplace-ui-reviews */

export const CAPITAL_MARKETS = 'CAPITAL_MARKETS';
/** @deprecated use marketplace-ui-reviews */

export const CHEMICALS = 'CHEMICALS';
/** @deprecated use marketplace-ui-reviews */

export const CIVIC_SOCIAL_ORGANIZATION = 'CIVIC_SOCIAL_ORGANIZATION';
/** @deprecated use marketplace-ui-reviews */

export const CIVIL_ENGINEERING = 'CIVIL_ENGINEERING';
/** @deprecated use marketplace-ui-reviews */

export const COMMERCIAL_REAL_ESTATE = 'COMMERCIAL_REAL_ESTATE';
/** @deprecated use marketplace-ui-reviews */

export const COMPUTER_NETWORK_SECURITY = 'COMPUTER_NETWORK_SECURITY';
/** @deprecated use marketplace-ui-reviews */

export const COMPUTER_GAMES = 'COMPUTER_GAMES';
/** @deprecated use marketplace-ui-reviews */

export const COMPUTER_HARDWARE = 'COMPUTER_HARDWARE';
/** @deprecated use marketplace-ui-reviews */

export const COMPUTER_NETWORKING = 'COMPUTER_NETWORKING';
/** @deprecated use marketplace-ui-reviews */

export const COMPUTER_SOFTWARE = 'COMPUTER_SOFTWARE';
/** @deprecated use marketplace-ui-reviews */

export const CONSTRUCTION = 'CONSTRUCTION';
/** @deprecated use marketplace-ui-reviews */

export const CONSUMER_ELECTRONICS = 'CONSUMER_ELECTRONICS';
/** @deprecated use marketplace-ui-reviews */

export const CONSUMER_GOODS = 'CONSUMER_GOODS';
/** @deprecated use marketplace-ui-reviews */

export const CONSUMER_SERVICES = 'CONSUMER_SERVICES';
/** @deprecated use marketplace-ui-reviews */

export const COSMETICS = 'COSMETICS';
/** @deprecated use marketplace-ui-reviews */

export const DAIRY = 'DAIRY';
/** @deprecated use marketplace-ui-reviews */

export const DEFENSE_SPACE = 'DEFENSE_SPACE';
/** @deprecated use marketplace-ui-reviews */

export const DESIGN = 'DESIGN';
/** @deprecated use marketplace-ui-reviews */

export const EDUCATION_MANAGEMENT = 'EDUCATION_MANAGEMENT';
/** @deprecated use marketplace-ui-reviews */

export const E_LEARNING = 'E_LEARNING';
/** @deprecated use marketplace-ui-reviews */

export const ELECTRICAL_ELECTRONIC_MANUFACTURING = 'ELECTRICAL_ELECTRONIC_MANUFACTURING';
/** @deprecated use marketplace-ui-reviews */

export const ENTERTAINMENT = 'ENTERTAINMENT';
/** @deprecated use marketplace-ui-reviews */

export const ENVIRONMENTAL_SERVICES = 'ENVIRONMENTAL_SERVICES';
/** @deprecated use marketplace-ui-reviews */

export const EVENTS_SERVICES = 'EVENTS_SERVICES';
/** @deprecated use marketplace-ui-reviews */

export const EXECUTIVE_OFFICE = 'EXECUTIVE_OFFICE';
/** @deprecated use marketplace-ui-reviews */

export const FACILITIES_SERVICES = 'FACILITIES_SERVICES';
/** @deprecated use marketplace-ui-reviews */

export const FARMING = 'FARMING';
/** @deprecated use marketplace-ui-reviews */

export const FINANCIAL_SERVICES = 'FINANCIAL_SERVICES';
/** @deprecated use marketplace-ui-reviews */

export const FINE_ART = 'FINE_ART';
/** @deprecated use marketplace-ui-reviews */

export const FISHERY = 'FISHERY';
/** @deprecated use marketplace-ui-reviews */

export const FOOD_BEVERAGES = 'FOOD_BEVERAGES';
/** @deprecated use marketplace-ui-reviews */

export const FOOD_PRODUCTION = 'FOOD_PRODUCTION';
/** @deprecated use marketplace-ui-reviews */

export const FUND_RAISING = 'FUND_RAISING';
/** @deprecated use marketplace-ui-reviews */

export const FURNITURE = 'FURNITURE';
/** @deprecated use marketplace-ui-reviews */

export const GAMBLING_CASINOS = 'GAMBLING_CASINOS';
/** @deprecated use marketplace-ui-reviews */

export const GLASS_CERAMICS_CONCRETE = 'GLASS_CERAMICS_CONCRETE';
/** @deprecated use marketplace-ui-reviews */

export const GOVERNMENT_ADMINISTRATION = 'GOVERNMENT_ADMINISTRATION';
/** @deprecated use marketplace-ui-reviews */

export const GOVERNMENT_RELATIONS = 'GOVERNMENT_RELATIONS';
/** @deprecated use marketplace-ui-reviews */

export const GRAPHIC_DESIGN = 'GRAPHIC_DESIGN';
/** @deprecated use marketplace-ui-reviews */

export const HEALTH_WELLNESS_FITNESS = 'HEALTH_WELLNESS_FITNESS';
/** @deprecated use marketplace-ui-reviews */

export const HIGHER_EDUCATION = 'HIGHER_EDUCATION';
/** @deprecated use marketplace-ui-reviews */

export const HOSPITAL_HEALTH_CARE = 'HOSPITAL_HEALTH_CARE';
/** @deprecated use marketplace-ui-reviews */

export const HOSPITALITY = 'HOSPITALITY';
/** @deprecated use marketplace-ui-reviews */

export const HUMAN_RESOURCES = 'HUMAN_RESOURCES';
/** @deprecated use marketplace-ui-reviews */

export const IMPORT_EXPORT = 'IMPORT_EXPORT';
/** @deprecated use marketplace-ui-reviews */

export const INDIVIDUAL_FAMILY_SERVICES = 'INDIVIDUAL_FAMILY_SERVICES';
/** @deprecated use marketplace-ui-reviews */

export const INDUSTRIAL_AUTOMATION = 'INDUSTRIAL_AUTOMATION';
/** @deprecated use marketplace-ui-reviews */

export const INFORMATION_SERVICES = 'INFORMATION_SERVICES';
/** @deprecated use marketplace-ui-reviews */

export const INFORMATION_TECHNOLOGY_SERVICES = 'INFORMATION_TECHNOLOGY_SERVICES';
/** @deprecated use marketplace-ui-reviews */

export const INSURANCE = 'INSURANCE';
/** @deprecated use marketplace-ui-reviews */

export const INTERNATIONAL_AFFAIRS = 'INTERNATIONAL_AFFAIRS';
/** @deprecated use marketplace-ui-reviews */

export const INTERNATIONAL_TRADE_DEVELOPMENT = 'INTERNATIONAL_TRADE_DEVELOPMENT';
/** @deprecated use marketplace-ui-reviews */

export const INVESTMENT_BANKING = 'INVESTMENT_BANKING';
/** @deprecated use marketplace-ui-reviews */

export const INVESTMENT_MANAGEMENT = 'INVESTMENT_MANAGEMENT';
/** @deprecated use marketplace-ui-reviews */

export const JUDICIARY = 'JUDICIARY';
/** @deprecated use marketplace-ui-reviews */

export const LAW_ENFORCEMENT = 'LAW_ENFORCEMENT';
/** @deprecated use marketplace-ui-reviews */

export const LAW_PRACTICE = 'LAW_PRACTICE';
/** @deprecated use marketplace-ui-reviews */

export const LEGAL_SERVICES = 'LEGAL_SERVICES';
/** @deprecated use marketplace-ui-reviews */

export const LEGISLATIVE_OFFICE = 'LEGISLATIVE_OFFICE';
/** @deprecated use marketplace-ui-reviews */

export const LEISURE_TRAVEL_TOURISM = 'LEISURE_TRAVEL_TOURISM';
/** @deprecated use marketplace-ui-reviews */

export const LIBRARIES = 'LIBRARIES';
/** @deprecated use marketplace-ui-reviews */

export const LOGISTICS_SUPPLY_CHAIN = 'LOGISTICS_SUPPLY_CHAIN';
/** @deprecated use marketplace-ui-reviews */

export const LUXURY_GOODS_JEWELRY = 'LUXURY_GOODS_JEWELRY';
/** @deprecated use marketplace-ui-reviews */

export const MACHINERY = 'MACHINERY';
/** @deprecated use marketplace-ui-reviews */

export const MANAGEMENT_CONSULTING = 'MANAGEMENT_CONSULTING';
/** @deprecated use marketplace-ui-reviews */

export const MARITIME = 'MARITIME';
/** @deprecated use marketplace-ui-reviews */

export const MARKET_RESEARCH = 'MARKET_RESEARCH';
/** @deprecated use marketplace-ui-reviews */

export const MARKETING_ADVERTISING = 'MARKETING_ADVERTISING';
/** @deprecated use marketplace-ui-reviews */

export const MECHANICAL_INDUSTRIAL_ENGINEERING = 'MECHANICAL_INDUSTRIAL_ENGINEERING';
/** @deprecated use marketplace-ui-reviews */

export const MEDIA_PRODUCTION = 'MEDIA_PRODUCTION';
/** @deprecated use marketplace-ui-reviews */

export const MEDICAL_DEVICES = 'MEDICAL_DEVICES';
/** @deprecated use marketplace-ui-reviews */

export const MEDICAL_PRACTICE = 'MEDICAL_PRACTICE';
/** @deprecated use marketplace-ui-reviews */

export const MENTAL_HEALTH_CARE = 'MENTAL_HEALTH_CARE';
/** @deprecated use marketplace-ui-reviews */

export const MILITARY = 'MILITARY';
/** @deprecated use marketplace-ui-reviews */

export const MINING_METALS = 'MINING_METALS';
/** @deprecated use marketplace-ui-reviews */

export const MOTION_PICTURES_FILM = 'MOTION_PICTURES_FILM';
/** @deprecated use marketplace-ui-reviews */

export const MUSEUMS_INSTITUTIONS = 'MUSEUMS_INSTITUTIONS';
/** @deprecated use marketplace-ui-reviews */

export const MUSIC = 'MUSIC';
/** @deprecated use marketplace-ui-reviews */

export const NANOTECHNOLOGY = 'NANOTECHNOLOGY';
/** @deprecated use marketplace-ui-reviews */

export const NEWSPAPERS = 'NEWSPAPERS';
/** @deprecated use marketplace-ui-reviews */

export const NON_PROFIT_ORGANIZATION_MANAGEMENT = 'NON_PROFIT_ORGANIZATION_MANAGEMENT';
/** @deprecated use marketplace-ui-reviews */

export const OIL_ENERGY = 'OIL_ENERGY';
/** @deprecated use marketplace-ui-reviews */

export const ONLINE_MEDIA = 'ONLINE_MEDIA';
/** @deprecated use marketplace-ui-reviews */

export const OUTSOURCING_OFFSHORING = 'OUTSOURCING_OFFSHORING';
/** @deprecated use marketplace-ui-reviews */

export const PACKAGE_FREIGHT_DELIVERY = 'PACKAGE_FREIGHT_DELIVERY';
/** @deprecated use marketplace-ui-reviews */

export const PACKAGING_CONTAINERS = 'PACKAGING_CONTAINERS';
/** @deprecated use marketplace-ui-reviews */

export const PAPER_FOREST_PRODUCTS = 'PAPER_FOREST_PRODUCTS';
/** @deprecated use marketplace-ui-reviews */

export const PERFORMING_ARTS = 'PERFORMING_ARTS';
/** @deprecated use marketplace-ui-reviews */

export const PHARMACEUTICALS = 'PHARMACEUTICALS';
/** @deprecated use marketplace-ui-reviews */

export const PHILANTHROPY = 'PHILANTHROPY';
/** @deprecated use marketplace-ui-reviews */

export const PHOTOGRAPHY = 'PHOTOGRAPHY';
/** @deprecated use marketplace-ui-reviews */

export const PLASTICS = 'PLASTICS';
/** @deprecated use marketplace-ui-reviews */

export const POLITICAL_ORGANIZATION = 'POLITICAL_ORGANIZATION';
/** @deprecated use marketplace-ui-reviews */

export const PRIMARY_SECONDARY_EDUCATION = 'PRIMARY_SECONDARY_EDUCATION';
/** @deprecated use marketplace-ui-reviews */

export const PRINTING = 'PRINTING';
/** @deprecated use marketplace-ui-reviews */

export const PROFESSIONAL_TRAINING_COACHING = 'PROFESSIONAL_TRAINING_COACHING';
/** @deprecated use marketplace-ui-reviews */

export const PROGRAM_DEVELOPMENT = 'PROGRAM_DEVELOPMENT';
/** @deprecated use marketplace-ui-reviews */

export const PUBLIC_POLICY = 'PUBLIC_POLICY';
/** @deprecated use marketplace-ui-reviews */

export const PUBLIC_RELATIONS_COMMUNICATIONS = 'PUBLIC_RELATIONS_COMMUNICATIONS';
/** @deprecated use marketplace-ui-reviews */

export const PUBLIC_SAFETY = 'PUBLIC_SAFETY';
/** @deprecated use marketplace-ui-reviews */

export const PUBLISHING = 'PUBLISHING';
/** @deprecated use marketplace-ui-reviews */

export const RAILROAD_MANUFACTURE = 'RAILROAD_MANUFACTURE';
/** @deprecated use marketplace-ui-reviews */

export const RANCHING = 'RANCHING';
/** @deprecated use marketplace-ui-reviews */

export const REAL_ESTATE = 'REAL_ESTATE';
/** @deprecated use marketplace-ui-reviews */

export const RECREATIONAL_FACILITIES_SERVICES = 'RECREATIONAL_FACILITIES_SERVICES';
/** @deprecated use marketplace-ui-reviews */

export const RELIGIOUS_INSTITUTIONS = 'RELIGIOUS_INSTITUTIONS';
/** @deprecated use marketplace-ui-reviews */

export const RENEWABLES_ENVIRONMENT = 'RENEWABLES_ENVIRONMENT';
/** @deprecated use marketplace-ui-reviews */

export const RESEARCH = 'RESEARCH';
/** @deprecated use marketplace-ui-reviews */

export const RESTAURANTS = 'RESTAURANTS';
/** @deprecated use marketplace-ui-reviews */

export const RETAIL = 'RETAIL';
/** @deprecated use marketplace-ui-reviews */

export const SECURITY_INVESTIGATIONS = 'SECURITY_INVESTIGATIONS';
/** @deprecated use marketplace-ui-reviews */

export const SEMICONDUCTORS = 'SEMICONDUCTORS';
/** @deprecated use marketplace-ui-reviews */

export const SHIPBUILDING = 'SHIPBUILDING';
/** @deprecated use marketplace-ui-reviews */

export const SPORTING_GOODS = 'SPORTING_GOODS';
/** @deprecated use marketplace-ui-reviews */

export const SPORTS = 'SPORTS';
/** @deprecated use marketplace-ui-reviews */

export const STAFFING_RECRUITING = 'STAFFING_RECRUITING';
/** @deprecated use marketplace-ui-reviews */

export const SUPERMARKETS = 'SUPERMARKETS';
/** @deprecated use marketplace-ui-reviews */

export const TELECOMMUNICATIONS = 'TELECOMMUNICATIONS';
/** @deprecated use marketplace-ui-reviews */

export const TEXTILES = 'TEXTILES';
/** @deprecated use marketplace-ui-reviews */

export const THINK_TANKS = 'THINK_TANKS';
/** @deprecated use marketplace-ui-reviews */

export const TOBACCO = 'TOBACCO';
/** @deprecated use marketplace-ui-reviews */

export const TRANSLATION_LOCALIZATION = 'TRANSLATION_LOCALIZATION';
/** @deprecated use marketplace-ui-reviews */

export const TRANSPORTATION_TRUCKING_RAILROAD = 'TRANSPORTATION_TRUCKING_RAILROAD';
/** @deprecated use marketplace-ui-reviews */

export const UTILITIES = 'UTILITIES';
/** @deprecated use marketplace-ui-reviews */

export const VENTURE_CAPITAL_PRIVATE_EQUITY = 'VENTURE_CAPITAL_PRIVATE_EQUITY';
/** @deprecated use marketplace-ui-reviews */

export const VETERINARY = 'VETERINARY';
/** @deprecated use marketplace-ui-reviews */

export const WAREHOUSING = 'WAREHOUSING';
/** @deprecated use marketplace-ui-reviews */

export const WHOLESALE = 'WHOLESALE';
/** @deprecated use marketplace-ui-reviews */

export const WINE_SPIRITS = 'WINE_SPIRITS';
/** @deprecated use marketplace-ui-reviews */

export const WIRELESS = 'WIRELESS';
/** @deprecated use marketplace-ui-reviews */

export const WRITING_EDITING = 'WRITING_EDITING';
/** @deprecated use marketplace-ui-reviews */

export const PREFER_NOT_TO_SAY = 'PREFER_NOT_TO_SAY';